export type ThemePref = 'system' | 'light' | 'dark'
export type Theme = 'light' | 'dark'

/** Per-device key (localStorage on the PWA, Application.Storage on the watch). */
export const THEME_STORAGE_KEY = 'matlist.theme'

export const resolveTheme = (pref: ThemePref, systemDark: boolean): Theme =>
  pref === 'system' ? (systemDark ? 'dark' : 'light') : pref

/** One-tap switch: flip what is on screen and remember it explicitly. */
export const toggleFrom = (pref: ThemePref, systemDark: boolean): ThemePref =>
  resolveTheme(pref, systemDark) === 'dark' ? 'light' : 'dark'

export const readPref = (raw: string | null | undefined): ThemePref =>
  raw === 'light' || raw === 'dark' || raw === 'system' ? raw : 'system'

/** Apply to <html data-theme>; "system" removes the attribute so the CSS media query decides. */
export function applyTheme(root: { setAttribute(k: string, v: string): void; removeAttribute(k: string): void }, pref: ThemePref) {
  if (pref === 'system') root.removeAttribute('data-theme')
  else root.setAttribute('data-theme', pref)
}

/** The resolved background, for <meta name="theme-color"> (ux/03 Theme switch). */
export const themeColorFor = (theme: Theme) => (theme === 'dark' ? '#111317' : '#F3F4F1')
